import { doc, getDocs, getDoc } from "firebase/firestore";
import { Board } from "@freetech/models/freelo";
import { db } from "@freetech/models/db";
import { NestedBoard } from "types/freelo/nested";

export const getBoard = async (boardId: string): Promise<NestedBoard> => {
  const boardRef = doc(db.boards, boardId);
  const boardDoc = await getDoc(boardRef);

  if (!boardDoc.exists()) {
    throw new Error("Board not found");
  }

  const boardData = boardDoc.data() as Board;
  const lists = await getDocs(db.lists(boardId));
  const listsData = lists.docs.map(doc => ({
    ...doc.data(),
    id: doc.id,
  }));

  const cards = await getDocs(db.cards(boardId));
  const cardsData = cards.docs.map(doc => ({
    ...doc.data(),
    id: doc.id,
  }));

  return {
    ...boardData,
    id: boardDoc.id,
    lists: listsData,
    cards: cardsData,
  };
};
